import { useState } from 'react'
import { mutate } from '@/runtime'
import type { PageResource } from '@/kinds/page/apply'
import type { TaskResource } from '@/kinds/task/apply'
import type { EditorApi } from '@/kinds/page/editor'
import { isOpen } from '@/kinds/task/schema'
import { Icon } from '@/lib/icons'
import { Sheet } from '@/components/ui'

/** Pick an existing task; the selected line becomes its checkbox. */
export const LinkTaskSheet = ({
  page,
  tasks,
  editorApi,
  onClose,
}: {
  page: PageResource
  tasks: TaskResource[]
  editorApi: EditorApi | null
  onClose: () => void
}) => {
  const [q, setQ] = useState('')
  const needle = q.trim().toLowerCase()
  const candidates = tasks
    .filter(
      (t) => !t.deleted_at && t.labels.ws === page.labels.ws && isOpen(t.status.state) && !t.spec.recurrence,
    )
    .filter((t) => !needle || t.spec.title.toLowerCase().includes(needle))
    .slice(0, 30)
  return (
    <Sheet open onClose={onClose} title="Link to a task">
      <p className="text-xs text-faint mb-2">
        The selected line becomes that task's checkbox: tick here, done everywhere.
      </p>
      <input
        value={q}
        onChange={(e) => setQ(e.target.value)}
        placeholder="Find a task…"
        className="w-full mb-2"
        autoFocus
        aria-label="Find a task"
        data-testid="link-task-search"
      />
      <ul className="flex flex-col max-h-72 overflow-y-auto" data-testid="link-task-list">
        {candidates.map((t) => (
          <li key={t.id}>
            <button
              type="button"
              className="w-full text-left text-sm px-2 min-h-9 rounded hover:bg-raised truncate"
              onClick={() => {
                editorApi?.linkSelection(t.id)
                void mutate.setEdge(t.id, page.id, 'references')
                onClose()
              }}
            >
              <Icon value={t.spec.icon} className="mr-1" />
              {t.spec.title}
            </button>
          </li>
        ))}
        {candidates.length === 0 && <li className="text-sm text-faint px-2 py-2">No open tasks match.</li>}
      </ul>
    </Sheet>
  )
}
